import React from 'react';
import PropTypes from 'prop-types';
import { Popup } from 'components/Popup/popup';
import { Dropdown } from 'components/Dropdown/Dropdown';
import ReassignWarningPopup from 'Request-Services/Components/ReassignWarningPopup';

class ReassignMultiplePopup extends React.Component {
  static propTypes = {
    onSaveReassignPopup: PropTypes.func,
    onCancelReassignPopup: PropTypes.func,
    sso: PropTypes.bool,
    userSelectList: PropTypes.array,
    onFetchUser: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state = {
      isModeAssignSub: false,
      user: null,
      isLoadingUser: false,
      isOpenWarningPopup: false
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.userSelectList) {
      this.setState({ isLoadingUser: false });
    }
  }

  onSave = () => {
    this.props.onSaveReassignPopup(this.state.user);
  };

  onSelectChange = (event, name) => {
    this.setState({
      [name]: event.value
    });
  };

  handleModeAssign = mode => {
    if (mode === 'sub') {
      this.setState({ isModeAssignSub: true, user: this.state.defaultUser });
    } else {
      this.setState({ isModeAssignSub: false, subcontractor: null });
    }
  };

  fetchUser = () => {
    this.setState(
      {
        isLoadingUser: true
      },
      () => {
        this.props.onFetchUser();
      }
    );
  };

  renderInternalUserDropdown = () => {
    const { sso, userSelectList } = this.props;

    const { isLoadingUser, user } = this.state;

    return (
      <Dropdown
        onChange={ref => {
          this.onSelectChange(ref, 'user');
        }}
        filter={true}
        className='filestring-dropdown filter-dropdown'
        onRemote={this.fetchUser}
        options={userSelectList.map(item => {
          return {
            ...item,
            text: `${item.text} (${item.extensionValue.email})`
          };
        })}
        loading={isLoadingUser}
        optionLabel='text'
        value={user}
        showClear={true}
        groupLabels={
          sso
            ? [
              {
                label: 'System users',
                field: 'sso',
                condition: [true]
              },
              {
                label: 'Builder users',
                field: 'sso',
                condition: [false, null]
              }
            ]
            : null
        }
        name='user'
        placeholder='-- Please select'
        style={{ width: '100%', paddingLeft: 0, paddingRight: 5 }}
      />
    );
  };

  render() {
    const { user, isOpenWarningPopup } = this.state;

    const disabled = !user;

    const { isModeAssignSub } = true;

    return (
      <React.Fragment>
        <Popup
          ref={ref => {
            this.reassignMultiple = ref;
          }}
          isHasFaded={true}
          className='close-multi-popup work-order-info-wrapper'
        >
          <div className='form-group' style={{ marginBottom: 0 }}>
            <p style={{ fontSize: 14, padding: '0 16px' }}>
              Select another assignee to assign the selected items
            </p>
            <div
              className='col-sm-12 control-label form-siteone-label'
              style={{ marginBottom: 5, padding: '0 16px' }}
            >
              Assigned to
              {/*<div
                className='btn-group btn-group-sm wo-assign-btn-group'
                role='group'
              >
                <button
                  type='button'
                  className={
                    'btn btn-secondary ' + (isModeAssignSub ? 'active' : '')
                  }
                  disabled
                  onClick={() => {
                    this.handleModeAssign('sub');
                  }}
                >
                  subcontractor
                </button>
                <button
                  type='button'
                  className={
                    'btn btn-secondary ' + (!isModeAssignSub ? 'active' : '')
                  }
                  onClick={() => {
                    this.handleModeAssign('user');
                  }}
                >
                  internal user
                </button>
                </div>*/}
            </div>
            <div className='col-sm-12'>
              {isModeAssignSub ? null : this.renderInternalUserDropdown()}
            </div>
          </div>
          <ul
            className='wo-popup-bottom-btn'
            style={{ marginTop: 0, borderTop: 0, marginBottom: 15 }}
          >
            <li>
              <button
                className='btn btn-primary btn-siteone-default btn-wo-edit'
                onClick={this.props.onCancelReassignPopup}
              >
                Cancel
              </button>
            </li>
            <li>
              <button
                className='btn btn-primary btn-siteone'
                onClick={() => {
                  this.setState({ isOpenWarningPopup: true });
                }}
                disabled={disabled}
              >
                Reassign
              </button>
            </li>
          </ul>
        </Popup>
        <ReassignWarningPopup
          isOpen={isOpenWarningPopup}
          onClose={this.props.onCancelReassignPopup}
          onProceed={this.onSave}
        />
      </React.Fragment>
    );
  }
}

export default ReassignMultiplePopup;



// WEBPACK FOOTER //
// ./src/Work-Orders/Components/ReassignMultiplePopup.js